var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Content",
    { attrs: { "app-name": "radio" } },
    [
      _c("Navigation", { attrs: { "station-data": _vm.stations } }),
      _vm._v(" "),
      _c(
        "AppContent",
        [
          _c(
            "div",
            { staticClass: "controls" },
            [
              _c(
                "Breadcrumbs",
                [_c("Breadcrumb", { attrs: { title: "Home", href: "#/" } })],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("Table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.pageLoading && _vm.stations.length > 0,
                expression: "!pageLoading && stations.length > 0"
              },
              {
                name: "resize",
                rawName: "v-resize",
                value: _vm.onResize,
                expression: "onResize"
              }
            ],
            attrs: { "station-data": _vm.stations, favorites: _vm.favorites },
            on: {
              doPlay: _vm.doPlay,
              doFavor: _vm.doFavor,
              toggleSidebar: _vm.toggleSidebar
            }
          }),
          _vm._v(" "),
          _vm.pageLoading
            ? _c("EmptyContent", { attrs: { icon: "icon-loading" } })
            : _vm._e(),
          _vm._v(" "),
          _vm.stations.length === 0 && !_vm.pageLoading
            ? _c(
                "EmptyContent",
                {
                  attrs: { icon: _vm.emptyContentIcon },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "desc",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(_vm.emptyContentDesc) +
                                "\n\t\t\t"
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    923469476
                  )
                },
                [
                  _vm._v(
                    "\n\t\t\t" + _vm._s(_vm.emptyContentMessage) + "\n\t\t\t"
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("Sidebar", {
        attrs: {
          "show-sidebar": _vm.showSidebar,
          "sidebar-station": _vm.sidebarStation
        },
        on: { toggleSidebar: _vm.toggleSidebar }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }